<template>
  <div class="expire">
    <div class="expire__icon">
      <div class="MuiBox-root css-79elbk">
        <!-- 背景圆环 -->
        <span class="MuiCircularProgress-root css-8xbmtt" :style="{ color: '#cccccc', width: '40px', height: '40px', transform: 'rotate(-90deg)' }">
          <svg class="MuiCircularProgress-svg css-13o7eu2" viewBox="22 22 44 44">
            <circle class="MuiCircularProgress-circle css-nbfpn7" cx="44" cy="44" r="20" fill="none" stroke-width="4"></circle>
          </svg>
        </span>
        <!-- 动态圆环 -->
        <span class="MuiCircularProgress-root css-gv9zyn" :style="{ color: progressColor, width: '40px', height: '40px', transform: 'rotate(-90deg)' }">
          <svg class="MuiCircularProgress-svg css-13o7eu2" viewBox="22 22 44 44">
            <circle ref="progressCircle" class="MuiCircularProgress-circle css-nbfpn7" cx="44" cy="44" r="20" fill="none" stroke-width="4"></circle>
          </svg>
        </span>
      </div>
    </div>
    <div class="expire__progress">
      <span class="expire__label">过期时间</span>
      <span class="expire__time" :style="{ color: timeColor }">{{ formattedTime }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "expireComponent",
  props:["expirationTime"],
  data() {
    const currentTime = Math.floor(Date.now() / 1000); // 当前时间（秒）
    const expirationTimeInSeconds = this.expirationTime?Math.floor(this.expirationTime / 1000):currentTime+60*15; // 传入的时间戳转换为秒
    const totalTime = expirationTimeInSeconds - currentTime; // 计算剩余总时间
    return {
      totalTime: totalTime > 0 ? totalTime : 0, // 总时间（秒）
      remainingTime: totalTime > 0 ? totalTime : 0, // 剩余时间
      interval: null,
    };
  },
  computed: {
    // 格式化剩余时间为 mm:ss
    formattedTime() {
      const minutes = String(Math.floor(this.remainingTime / 60)).padStart(2, '0');
      const seconds = String(this.remainingTime % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    // 根据剩余时间设置文字颜色
    timeColor() {
      const progressRatio = this.remainingTime / this.totalTime;
      return progressRatio > 0.6 ? '#ff9800' : '#666';
    },
    // 根据剩余时间比例设置圆环颜色
    progressColor() {
      const progressRatio = this.remainingTime / this.totalTime;
      if (progressRatio > 0.6) {
        return '#ff9800'; // 绿色（进度高）
      } else {
        return '#ff3d4d'; // 红色（进度低）
      }
    },
  },
  mounted() {
    this.startCountdown();
    console.log(this.expirationTime)
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    startCountdown() {
      const circumference = 2 * Math.PI * 20; // 圆的周长（r = 20）
      this.$refs.progressCircle.style.strokeDasharray = `${circumference}`;
      this.interval = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime -= 1;
          const offset = (this.remainingTime / this.totalTime) * circumference;
          this.$refs.progressCircle.style.strokeDashoffset = `${circumference - offset}`;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.expire {
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 16px;
  gap: 16px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;

  .expire__icon {
    align-items: center;
    display: flex;

    .css-gv9zyn {
      display: inline-block;
      left: 0px;
      position: absolute;
      top: 0px;
      transition: color 0.3s;

      .MuiCircularProgress-circle {
        stroke-linecap: round;
      }
    }

    .css-nbfpn7 {
      stroke: currentColor;
      transition: stroke-dashoffset 300ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    .css-79elbk {
      position: relative;
    }

    .css-8xbmtt {
      display: inline-block;
      color: var(--backgroundNegativeOverlay);
      transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    .css-13o7eu2 {
      display: block;
    }

    circle {
      cx: 44;
      cy: 44;
      r: 20;
      fill: none;
      stroke-width: 4;
    }
  }

  .expire__progress {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .expire__label {
      color: #666;
    }

    .expire__time {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      width: 72px;
    }
  }
}
</style>
